import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { SanitizedFeedSectionArticle } from "@typings/Cue";
import { getUrlQuery } from "@util/helpers";

/**
 * Returns the card props for the Podcast keyword component.
 * @param articles - The articles to be displayed in the component.
 * @param ref - The reference to be used for the link.
 * @returns {ComponentProps<typeof Card>[]} - The card props for the Podcast keywordcomponent.
 */
export const getPodcastKeywordCardProps = (
  articles: SanitizedFeedSectionArticle[],
  ref?: string
): ComponentProps<typeof Card>[] => {
  const linkParams = ref ? new URLSearchParams({ ref }) : undefined;

  const cardProps = articles.map(
    ({ id, title, urlPath, media, blurb, kicker, sections, paywall }) => {
      const mainSection = sections?.[0];
      const mainMedia = media[0];
      const imgSrc = mainMedia?.landscape?.url;
      const imgWidth = mainMedia?.landscape?.width;
      const imgHeight = mainMedia?.landscape?.height;

      const props: ComponentProps<typeof Card> = {
        id,
        title,
        link: urlPath + getUrlQuery(urlPath, linkParams),
        thumbnail:
          imgSrc && imgWidth && imgHeight
            ? {
                src: imgSrc,
                alt: mainMedia.alt || mainMedia.caption || "",
                width: imgWidth,
                height: imgHeight,
              }
            : undefined,
        blurb,
        kicker: kicker?.fields?.[0]?.value?.toUpperCase(),
        defaultImage: { directoryName: mainSection?.uniqueName || "" },
        displayPaywall: paywall?.contentAccess === "1",
      };

      return props;
    }
  );

  return JSON.parse(JSON.stringify(cardProps));
};
